var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$s.banner},[_c('div',{class:_vm.$s.content},[_c('strong',[_vm._v(_vm._s(_vm.pageData.header.title))]),_c('o-button',{class:[_vm.$s.button],attrs:{"href":"/register","variant":"primary"}},[_vm._v("\n      "+_vm._s(_vm.pageData.header.button)+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }